export default __webpack_public_path__ + "static/media/space.42053413.png";